import { createContext, useContext, useState, ReactNode } from 'react';

interface TourContextType {
  runTour: boolean;
  startTour: () => void;
  stopTour: () => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export function TourProvider({ children }: { children: ReactNode }) {
  const [runTour, setRunTour] = useState(false);

  const startTour = () => {
    // Add a small delay to ensure all elements are mounted
    setTimeout(() => setRunTour(true), 100);
  };
  
  const stopTour = () => setRunTour(false);

  return (
    <TourContext.Provider value={{ runTour, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}